import { render, staticRenderFns } from "./mbKeyfeature.vue?vue&type=template&id=24e4bc37&scoped=true&"
import script from "./mbKeyfeature.vue?vue&type=script&lang=js&"
export * from "./mbKeyfeature.vue?vue&type=script&lang=js&"
import style0 from "./mbKeyfeature.vue?vue&type=style&index=0&id=24e4bc37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e4bc37",
  null
  
)

export default component.exports